<template>
    <div class="wrap">

        <!-- 07_비밀번호재설정 02_재설정popup -->
        <div class="full_modal show" id="resetPwd_popup">
            <div class="modal_box">
                <div class="modal_head inner">
                    <div class="h_left"></div>
                    <div class="h_title">비밀번호 재설정</div>
                </div>
                <div class="modal_body inner">
                    <div class="form_box">
                        <div class="input_box">
                            <input type="password" id="reset_pwd" class="input_text" placeholder="비밀번호 입력"
                                v-model="pwd">
                        </div>
                        <div class="input_box">
                            <input type="password" id="reset_pwdchk" class="input_text" placeholder="비밀번호 확인 입력"
                                v-model="pwdchk">
                        </div>
                    </div>
                </div>
                <div class="modal_foot inner">
                    <button type="button" class="btn full submit_btn" @click="resetPasswordReq">확인</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { isValidPassword } from '@/utils';
import { useStore } from 'vuex';
import { resetPassword } from '@/api';
const store = useStore();
const route = useRoute();
const router = useRouter();
const pwd = ref('');
const pwdchk = ref('');

const resetPasswordReq = async () => {
    if (!isValidPassword(pwd.value)) {
        store.commit('setUserInfoModalContent', '비밀번호는 8자 이상 20자 이하의 영문 대소문자와 숫자, 특수문자만 사용해주세요');
    } else if (pwd.value !== pwdchk.value) {
        store.commit('setUserInfoModalContent', '비밀번호가 일치하지 않습니다.');
    } else {
        let result = await resetPassword(route.params.token, pwd.value, pwdchk.value);
        if (result.status == 200) {
            router.push("/pwd_find/success");
        } else {
            store.commit('setUserInfoModalContent', result.message);
        }
    }
}

</script>

<style></style>